export default class NoLatestLoanError extends Error {
  constructor() {
    super('No latest loan');
  }
}
